import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import './PitSummary.scss';
import stores from '../../../models/Stores';
import { PitSummaryVM } from './PitSummaryVM';
import { Notification } from '../../common/Notification/Notification';
import { DesignSummaryTable } from 'cd-eft/components/common/DesignSummaryTable/DesignSummaryTable';
import { DesignSummaryButtons } from 'cd-eft/components/Design/common/DesignSummaryButtons';

const { pitDesignStore, designStore } = stores.AppStore;

const PitSummaryComponent = (props) => {
  const inputRef: any = useRef([]);
  const vm = useRef(new PitSummaryVM(props, inputRef)).current;

  useEffect(() => {
    vm.getDesignElements();
  }, [designStore.currentSurface.surfaceDefId]);

  return (
    <div className="pit-summary">
      {vm.error && vm.errorMsg ? (
        <div className="mt-3 err error-message">
          <h3 className="usa-error-message" id="client--message" role="alert">
            {vm.errorMsg}
          </h3>
        </div>
      ) : null}

      {!vm.error && !vm.errorMsg ? (
        <div className="design-summary-table">
          <DesignSummaryTable
            headers={['Select', 'Id', 'Name', 'Design Type', 'Actions']}
            accessVariableNameArray={[
              'designElementId',
              'designElementId',
              'designElementName',
              'designElementTypeId.name',
              'actions',
            ]}
            data={pitDesignStore.pitSummaryTable}
            selectColumn={true}
            checkboxEvent={vm.handleCheckboxChange}
            actionsColumn={true}
            actionMenuActions={vm.elementActions}
          />
          {pitDesignStore.pitSummaryTable.length === 0 && !pitDesignStore.showLoader && !designStore.isLoading ? (
            <div className="h4 m-5 text-center">Add your first Pit</div>
          ) : null}
        </div>
      ) : null}
      <DesignSummaryButtons
        panel="Pit"
        disableAdd={false}
        disableRefreshElements={vm.jobExecuting || pitDesignStore.pitSummaryTable.length === 0}
        disableRebuildSurface={vm.jobExecuting || pitDesignStore.pitSummaryTable.length === 0}
        buttontype={vm.displayType === 'surface'}
        add={vm.addPit}
        refreshElements={vm.displaySelectedPits}
        rebuildSurface={vm.onClickSurface}
      />
      <Notification
        type={vm.notification.type}
        message={vm.notification.message}
        header={vm.notification.header}
        hidden={vm.notification.hidden}
        timestamp={vm.notification.timestamp}
      />
    </div>
  );
};

export const PitSummary = observer(PitSummaryComponent);
